export default "__VITE_ASSET__lm3fynhS__"